const contactItems = [
  {
    label: 'Address',
    icon: 'ri-map-pin-2-line',
    lines: ['CVETKA MANOJLOVICA 23'],
  },
  {
    label: 'City',
    icon: 'ri-building-2-line',
    lines: ['Subotica'],
  },
  {
    label: 'Zip',
    icon: 'ri-mail-open-line',
    lines: ['451259'],
  },
  {
    label: 'Country',
    icon: 'ri-earth-line',
    lines: ['Serbia'],
  },
  {
    label: 'Email',
    icon: 'ri-at-line',
    lines: ['contact@blanodoo.com'],
  },
  {
    label: 'Number',
    icon: 'ri-phone-line',
    lines: ['+1 6627296773'],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#1A2332] py-28 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[3px] text-[#5ee7d0]/60 font-medium mb-4">Get In Touch</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
            Contact Us
          </h2>
          <p className="mt-4 text-base text-white/50 max-w-md mx-auto leading-relaxed">
            Have questions about our products or want to reach our team? We are here to help.
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactItems.map((item) => (
            <div
              key={item.label}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#5ee7d0]/10 text-[#5ee7d0] flex-shrink-0">
                <i className={`${item.icon} text-lg`} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-[2px] text-white/40 font-medium mb-2">
                  {item.label}
                </p>
                {item.lines.map((line) => (
                  <p key={line} className="text-white text-sm leading-relaxed">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
